import { useDrawer } from '@app/src/components/Drawer/DrawerContext'
import DrawerViewDiscardAnswer from '@app/src/components/Drawer/Views/DrawerViewDiscardAnswer'
import { DeleteOutlined } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

interface DiscardAiAnswerButtonProps {
  responseItemId: number
  responseId: number
}

const DiscardAiAnswerButton = ({ responseItemId, responseId }: DiscardAiAnswerButtonProps): JSX.Element => {
  const { formatMessage } = useIntl()
  const { openDrawer } = useDrawer()

  const handleClick = () => {
    openDrawer(<DrawerViewDiscardAnswer responseItemId={responseItemId} responseId={responseId} />)
  }

  return (
    <Tooltip title={formatMessage({ id: 'reporting.discardAiAnswer.discard' })} arrow>
      <IconButton
        data-pdf-hide
        size="small"
        onClick={handleClick}
        sx={({ palette }) => ({ color: palette.semantic.error })}
        data-testid="discard-ai-answer"
      >
        <DeleteOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
  )
}

export default DiscardAiAnswerButton
